/**
 * @generated SignedSource<<cba4bc02143ae251f49701d70c49b0c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedFeaturedCollection_itemSearch$data = {
  readonly featuredCollection: {
    readonly linkData: {
      readonly text: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
    };
    readonly imageUrl: string | null;
  } | null;
  readonly " $fragmentType": "SbSharedFeaturedCollection_itemSearch";
};
export type SbSharedFeaturedCollection_itemSearch$key = {
  readonly " $data"?: SbSharedFeaturedCollection_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedFeaturedCollection_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedFeaturedCollection_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FeaturedCollection",
      "kind": "LinkedField",
      "name": "featuredCollection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "237a556eebebb0ecd72b623b1d6c4a1d";

export default node;
